import { Button, IconButton } from '@dropbox/dig-components/buttons';
import { Drawer } from '@dropbox/dig-components/drawer';
import { Text } from '@dropbox/dig-components/typography';
import { Split } from '@dropbox/dig-foundations';
import { CloseLine } from '@dropbox/dig-icons/dist/mjs/assets/ui-icon/line/close';
import { UIIcon } from '@dropbox/dig-icons/dist/mjs/ui_icon';
import { atom, useAtom } from 'jotai';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSignerContext } from 'signer-app/signer-experience/signer-experience';
import { useShouldShowDrawer } from 'signer-app/utils/use-should-show-drawer';
import { AttachmentsDrawerContent } from './attachments-drawer-content';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';
import { useBundleProps } from 'signer-app/bundle-props';

export const isAttachmentsDrawerOpen = atom(false);

export function AttachmentsDrawer() {
  const [isOpen, setIsOpen] = useAtom(isAttachmentsDrawerOpen);
  const { attachmentSlots } = useSignerContext();
  const uploadedAttachmentsNumber = attachmentSlots.filter(
    (slot) => slot.uploadedAt,
  ).length;
  const attachmentsNumber = attachmentSlots.length;
  const isUsingDrawerFlow = useShouldShowDrawer();
  const { hasCustomStyles } = useBundleProps();

  return (
    <Drawer.ModalDrawer
      onRequestClose={() => setIsOpen(false)}
      aria-label="Attachments drawer"
      alignment="right"
      width={isUsingDrawerFlow ? '100%' : '463px'}
      isOpen={isOpen}
    >
      <Drawer.Header>
        <Drawer.Layout>
          <Drawer.LayoutItem width="fill">
            <Text isBold>
              <FormattedMessage
                id="f51f1e5211b9dd1c28c9419d73cdbbb1cebc9d3412ea14f2193c0f4870fbd805"
                description="text in signer flow of attachment page, simply indicating it is a attachment page"
                defaultMessage="Upload attachments"
              />
            </Text>
          </Drawer.LayoutItem>
          <Drawer.LayoutItem width="hug">
            <WhiteLabelThemeProvider mode="bright">
              <IconButton
                variant="transparent"
                onClick={() => setIsOpen(false)}
              >
                <UIIcon src={CloseLine} aria-label="Close attachments drawer" />
              </IconButton>
            </WhiteLabelThemeProvider>
          </Drawer.LayoutItem>
        </Drawer.Layout>
      </Drawer.Header>
      <Drawer.Body>
        <AttachmentsDrawerContent />
      </Drawer.Body>
      <Drawer.Footer>
        <Split alignY="center" gap="Micro XSmall">
          <Split.Item width="fill">
            <Text color="subtle">
              <FormattedMessage
                id="88154aaafb7cbe31c6f78ac842744a6cf7d8ae353bc7ffdeef0a7832761b70b7"
                description="text in signer flow of attachment page, informing signer that sender has requested documents to be attached with the signature request"
                defaultMessage="{ uploadedAttachmentsNumber }/{ attachmentsNumber } attachments added"
                values={{ uploadedAttachmentsNumber, attachmentsNumber }}
              />
            </Text>
          </Split.Item>

          <Split.Item>
            <WhiteLabelThemeProvider mode="bright">
              <Button
                variant={hasCustomStyles ? 'outline' : 'opacity'}
                onClick={() => setIsOpen(false)}
              >
                <FormattedMessage
                  id="003357d40ce576f7dad7bc00ca16e702a29bda8a30c83880128afc53c13f3190"
                  description="attachments drawer footer close button"
                  defaultMessage="Close"
                />
              </Button>
            </WhiteLabelThemeProvider>
          </Split.Item>
          <Split.Item>
            <WhiteLabelThemeProvider mode="bright">
              <Button variant="primary" onClick={() => setIsOpen(false)}>
                <FormattedMessage
                  id="fadcf44f1ae699b64a992de994f3b8d8694595d169fc92e7092967ea0cc27a62"
                  description="attachments drawer footer done button"
                  defaultMessage="Done"
                />
              </Button>
            </WhiteLabelThemeProvider>
          </Split.Item>
        </Split>
      </Drawer.Footer>
    </Drawer.ModalDrawer>
  );
}
